<template>
  <div class="conten" :style="backgroundStyle">
    <div class="top-h2">
      <h2 style="width: 100%; text-align: center; font-size: 30px; color: #fff">
        {{ title }}
      </h2>
    </div>

    <div class="box">
      <div class="content">
        <div
          class="content-item"
          v-for="item in huodongData"
          @click="goPingfen(item)"
          :key="item.id"
        >
          <div class="background-Image">
            <el-image
              :src="'https://xileqiniu.hnzsnetwork.cn/' + item.userimg"
              fit="fill"
              style="width: 50px; height: 50px"
            >
              <div slot="error">
                <el-image
                  src="https://pfhd.hnzsnetwork.cn/static/images/screen/livemark/default.png"
                  fit="fill"
                />
              </div>
            </el-image>
          </div>
          <div class="content-right">
            <div class="title-top">{{ item.username }}</div>
            <div class="title-bottom" v-if="item.score != null">
              最终得分:{{ item.score }}
            </div>
            <div class="title-bottom" v-if="item.score == null">待评分</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getconfiglivemarkList } from "@/utils/http.js";
export default {
  data() {
    return {
      firstRowList: [], // 第一行数据

      testData: [],

      huodongId: this.$route.query.huodongId,
      bgimg: "", //背景图片
      baseurl: "https://xileqiniuzdy.hnzsnetwork.cn/",
    };
  },
  created() {
    console.log("huodongId", this.$route.query.huodongId);
    this.gethuodongData();
    getconfiglivemarkList({ huodongId: this.huodongId }).then((res) => {
      this.bgimg = this.baseurl + res.rows[0].bgimg;
    });
  },
  computed: {
    ...mapGetters(["huodongData", "title"]),
    backgroundStyle() {
      console.log("this.bgimg", this.bgimg);
      return {
        backgroundImage: `url(${this.bgimg})`,
        // 其他样式
      };
    },
  },
  mounted() {
    console.log("this.huodongData==", this.huodongData);
    const huodongId = this.$route.query.huodongId; // "John"
  },
  methods: {
    ceshi() {
      console.log("huodongId", this.$route.query);
    },
    gethuodongData() {
      this.$store.dispatch("GethuodongData", {
        huodongId: this.$route.query.huodongId,
      });
    },
    goPingfen(data) {
      this.$router.push({
        name: "Home",
        query: { huodongId: this.$route.query.huodongId, id: data.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.conten {
  width: 100%;
  background-size: 100% 100%;
  height: 100%;
}

.top-h2 {
  display: flex;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: 20%;
}

/* 垂直滚动条样式 */
/* 宽度 */
::-webkit-scrollbar {
  width: 12px;
}

/* 背景色 */
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}

/* 水平滚动条样式 */
/* 高度 */
::-webkit-scrollbar {
  height: 12px;
}

/* 背景色 */
::-webkit-scrollbar-track {
  background: hsla(0, 0%, 37%, 0.1);
  border-radius: 10px;
}

/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background: hsla(0, 0%, 100%, 0.1);
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  border-radius: 10px;
  background: hsla(0, 0%, 100%, 0.1);
}

::v-deep .el-switch {
  width: 80px;
}

::v-deep .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
  z-index: 1;
  right: 40px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  left: 40px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
  display: block;
}

::v-deep .el-switch .el-switch__core {
  width: 60px !important;
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 55px;
}

.box {
  width: 80%;
  height: 75%;
  position: fixed;
  top: 17%;
  left: 0;
  right: 0;
  margin: auto;

  .box-top {
    display: flex;
    align-items: center;
    height: 50px;
    position: absolute;
    width: 209px;
    right: 15px;
    justify-content: space-around;

    .detail {
      color: #fff;
      border: 1px solid #fff;
      text-align: center;
      width: 91px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      border-radius: 17px;
    }
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // width: 1000px;
  height: 85%;

  overflow-y: auto;

  .content-item {
    width: 25%;
    height: 120px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    margin: 0 36px 36px 0;
    font-size: 38px;
    border: 2px solid transparent;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    cursor: pointer;
    background-image: url(../assets/userbg.png);
    background-size: 100% 100%;

    .background-Image {
      width: 50px;
      height: 50px;
      border-radius: 5px;

      background-size: 100% 100%;
    }

    .content-right {
      width: 57%;
      height: 100%;
      margin-top: 64px;

      .title-top {
        color: #fff;
        font-size: 18px;
      }

      .title-bottom {
        color: #fff;
        font-size: 16px;
        margin-top: 8px;
      }
    }
  }
}

// --------------------
.box {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  .flex-row {
    flex-flow: row wrap;
    align-content: flex-start;
    width: 90%;
    height: 45%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .flex-item {
      width: 13%;
      height: 100%;
      cursor: pointer;
      margin-bottom: 10px;
    }
  }
}
</style>
